import React, { FunctionComponent } from 'react';
import ParentComponent, {
  TParentComponentProps,
} from '@views/components/common/ParentComponent';
import classNames from 'classnames';

export type TShopLayoutContentProps = TParentComponentProps & {};

export const ShopLayoutContent: FunctionComponent<TShopLayoutContentProps> = ({
  className,
  ...otherProps
}) => {
  const cx = classNames({
    [className]: !!className,
  });

  return <ParentComponent className={cx} {...otherProps} />;
};

ShopLayoutContent.defaultProps = {
  as: 'aside',
  defaultClassName: 'shop-layout__content',
};

export default ShopLayoutContent;
